import PropTypes from 'prop-types'
import React from 'react'

import BuyBigModal from './BuyBigModal'

const BuyTerminiDiUtilizzo = ({ display, onClose }) => (
  <BuyBigModal
    display={display}
    h4="Termini di Utilizzo brumbrum"
    onClose={onClose}
  >
    <div className="legals__content">
      <p>
        L’accesso e l’interazione con questo sito www.brumbrum.it (“Sito”), di
        titolarità di brumbrum S.p.A. (“brumbrum”) comporta la tacita
        accettazione di quanto previsto nei seguenti termini di utilizzo del
        Sito (“Termini di utilizzo”), nonché delle disposizioni contenute nella{' '}
        <a href="/privacy-policy-e-cookies" target="_blank">
          Privacy Policy
        </a>
        .
      </p>
      <p>
        In ogni caso l’avvio del processo di acquisto sul Sito può avvenire solo
        dopo la validazione da te effettuata dei dati conferiti all’atto della
        registrazione con la conseguenza, come sotto specificato, che a te
        saranno riferibili i fatti e gli atti compiuti per mezzo dei certificati
        e dei codici identificativi a te assegnati nonché l’utilizzo dei device
        (PC, tablet, Smartphone, etc.etc.) su cui tali codici e/o certificati
        sono stati installati al momento del collegamento.Ulteriori condizioni e
        termini sostitutivi e/o integrativi dei presenti “Termini di utilizzo”
        possono essere indicati in altre pagine visualizzabili all’interno del
        Sito, accedendo a specifici servizi.
      </p>
      <p>
        Il mancato rispetto di termini e delle condizioni di utilizzo del Sito e
        degli specifici servizi può comportare il blocco dell’accesso da parte
        dell’utente al Sito e, nel caso in cui venissero rilevate violazioni di
        norme di legge, la segnalazione alle autorità competenti.
      </p>
      <p>
        <strong>
          Ti invitiamo pertanto a leggere con attenzione i presenti Termini di
          Utilizzo prima di accedere al Sito ed utilizzare i nostri servizi.
        </strong>
      </p>

      <h4>Informazioni generali</h4>
      <p>
        Il Sito ha lo scopo di farti conoscere tutte le attività che svolge
        brumbrum e di aiutarti nella ricerca di informazioni relative ai
        prodotti ed ai servizi offerti dalla medesima. L’acquisto dei prodotti e
        dei servizi offerti da brumbrum presuppone la registrazione al Sito.
        Attraverso il Sito potrai acquistare sia veicoli usati venduti
        direttamente da brumbrum che altri prodotti e servizi offerti da terze
        parti. Nel secondo caso potresti essere direzionato verso altri Siti che
        potrebbero subordinare la navigazione all’accettazione di ulteriori e/o
        diverse condizioni di utilizzo.
      </p>

      <h4>Utilizzo di servizi di comunicazione</h4>
      <p>
        Questo Sito può contenere servizi per inviare messaggi o possibilità di
        comunicazione, i quali sono progettati per consentirti di comunicare con
        gli altri utenti.
      </p>
      <p>
        Ti obblighi ad utilizzare i suddetti servizi di comunicazione solo per
        inviare, spedire, ricevere messaggi e materiali correlati all’utilizzo
        del Sito e per interagire con esso. brumbrum non ha alcun obbligo di
        controllare i servizi di comunicazione. brumbrum si riserva, tuttavia,
        il diritto di rivedere i materiali pubblicati nei servizi di
        comunicazione e di rimuoverli integralmente o parzialmente, a sua
        esclusiva e insindacabile discrezione, nonché di interrompere l’accesso
        dell’utente ad uno o a tutti i servizi di comunicazione in ogni momento,
        senza preavviso e per qualsiasi ragione.
      </p>
      <p>
        brumbrum non si assume alcuna responsabilità per l’utilizzo dei servizi
        di comunicazione e per le eventuali azioni risultanti dalla tua
        partecipazione agli stessi.
      </p>

      <h4>Codici identificativi, certificati ed account</h4>
      <p>
        Tutte le manifestazioni di volontà, gli atti e i fatti produttivi di
        effetti giuridici ed economici compiuti sul Sito utilizzando gli
        strumenti di autenticazione informatica approntati da brumbrum (codici
        identificativi, certificati e/o account,) a te assegnati e da te
        preventivamente validati con l’utilizzo dell’indirizzo e/o del canale di
        comunicazione elettronica da te prescelto ti saranno attributi in
        maniera incontestabile.
      </p>
      <p>
        Sei responsabile della riservatezza dei tuoi codici identificativi,
        certificati ed account e ti impegni ad utilizzarli personalmente ed
        esclusivamente sui device (PC, tablet, Smartphone, etc.etc.) su cui tali
        strumenti sono stati installati al momento in cui li hai validati
        collegandoti al Sito con il link inviato al tuo indirizzo sul canale di
        comunicazione elettronica prescelto al momento della Tua registrazione
        al Sito.
      </p>
      <p>
        Ti impegni a comunicare immediatamente a brumbrum qualsiasi utilizzo non
        autorizzato dei codici identificativi e/o dell’account nonché qualsiasi
        altro fatto che ne violi la sicurezza.
      </p>
      <p>
        brumbrum comunque non sarà ritenuta responsabile per eventuali danni
        causati dall'utilizzo dei codici identificativi o dell’account da parte
        di un'altra persona, con o senza la tua autorizzazione, e
        indipendentemente dal fatto che ne sei a conoscenza. Tuttavia, sarai
        ritenuto responsabile di eventuali perdite subite da brumbrum e/o da
        terzi a causa dell'utilizzo dei tuoi codici identificativi e/o del tuo
        account da parte di un altro soggetto.
      </p>

      <h4>Proprietà intellettuale e limiti di utilizzo</h4>
      <p>
        I contenuti del Sito (quali a titolo esemplificativo, testi, messaggi,
        file audio e video, immagini, pulsanti di icone, raccolte di dati,
        grafica, marchi ed ogni altra informazione o materiale disponibile),
        sono protetti, anche penalmente, dalla vigente normativa sul diritto
        d’autore e dalle altre norme a protezione della proprietà intellettuale
        (copyright); questi possono essere utilizzati solo in conformità a tali
        normative. Ogni diritto sui contenuti è riservato a brumbrum e/o ai
        rispettivi autori. È pertanto vietata la riproduzione dei contenuti del
        Sito a uso commerciale o comunque al fine di trarne una qualsiasi
        utilità.
      </p>
      <p>
        Non puoi riprodurre e utilizzare, in qualsiasi contesto, senza il
        consenso scritto di brumbrum, salvo i casi espressamente previsti dalla
        normativa vigente, forme e modalità o i contenuti del Sito. Le note di
        copyright, gli autori ove indicati o la fonte stessa devono essere
        citati in tutte le pubblicazioni, in qualunque forma realizzate e/o
        diffuse.
      </p>
      <p>
        I diritti di privativa industriale e intellettuale sui contenuti di
        questo Sito resteranno in ogni caso di proprietà dei titolari degli
        stessi.
      </p>
      <p>
        È rigorosamente proibito qualsiasi uso dei marchi e/o dei loghi e/o
        delle denominazioni brumbrum nonché del testo o del materiale grafico
        contenuto in questo Sito per esprimere in qualsiasi modo, o
        rappresentare, la tua adesione, sponsorizzazione, affiliazione o
        associazione con brumbrum.
      </p>
      <p>
        Le pagine del Sito potrebbero contenere altre avvertenze sulla proprietà
        e informazioni sul copyright, le cui condizioni dovranno essere
        osservate e seguite.
      </p>
      <p>
        Eventuali segnalazioni concernenti le violazioni del diritto d'autore
        dovranno essere inviate a brumbrum all’indirizzo pubblicato sul Sito
        (ovvero <a href="mailto:copyright@brumbrum.it">copyright@brumbrum.it</a>
        ).
      </p>

      <h4>Software disponibili</h4>
      <p>
        I software (se disponibili) che possono essere visualizzati e/o
        scaricati da questo Sito sono di proprietà di brumbrum e/o dei suoi
        fornitori e sono protetti dalle leggi sul diritto d'autore e dai
        trattati internazionali.
      </p>
      <p>
        L'uso del software è regolato dalle eventuali condizioni del contratto
        di licenza di utilizzo accluso al software stesso. Non sei autorizzato
        ad installare o usare software accompagnati da contratti di licenza
        qualora non acconsenti preventivamente ai termini e alle condizioni
        indicati nei medesimi contratti.
      </p>

      <h4>Collegamenti a siti web di terzi </h4>
      <p>
        brumbrum non si assume alcuna responsabilità per i contenuti di siti
        esterni raggiungibili tramite link- ipertestuali (link) che si trovano
        sul Sito. Il Sito prevede questi collegamenti al solo scopo di fornire
        facilitare la tua navigazione in rete. Il collegamento a siti esterni,
        però, non implica l’approvazione del loro contenuto da parte di
        brumbrum.
      </p>
      <p>
        Tali siti sono totalmente indipendenti dal Sito di brumbrum. brumbrum
        non ha alcun potere di controllo, né diretto né indiretto, sugli stessi
        e/o sul loro contenuto o utilizzo.
      </p>
      <p>
        Riconosci e accetti che nessun tipo di responsabilità, neanche
        indiretta, potrà essere imputata a brumbrum per i contenuti, i prodotti
        o altri beni/servizi nonché per l’utilizzazione dei siti web di cui
        sopra, e che l’esistenza nel Sito di un collegamento ipertestuale (link)
        verso un altro sito non comporta alcun tipo di approvazione o
        accettazione di responsabilità da parte di brum brum circa il contenuto
        o l’utilizzazione del portale/sito collegato.
      </p>

      <h4>Usi illegali o proibiti</h4>
      <p>
        Non dovrai utilizzare il Sito e i relativi servizi per scopi illegali o
        contrari ai presenti “Termini di utilizzo”, o con modalità che
        potrebbero danneggiarlo, renderlo inagibile, sovraccaricarlo o
        deteriorarlo ovvero interferire con l'uso e il godimento dello stesso da
        parte degli altri utenti. Non potrai tentare di accedere in modo non
        autorizzato al Sito o ai relativi servizi, ad altri account, a sistemi o
        reti connessi al Sito o ai relativi servizi tramite operazioni di
        pirateria informatica, contraffazione della password o altri mezzi. Non
        potrai ottenere o tentare di ottenere materiali o informazioni tramite
        mezzi che non siano intenzionalmente resi disponibili o forniti tramite
        il Sito o i relativi servizi.
      </p>

      <h4>Virus informatici</h4>
      <p>
        brumbrum non garantisce che il Sito sia privo di virus, sebbene disponga
        di sistemi antivirus periodicamente aggiornati.
      </p>
      <p>
        Considerate le innumerevoli modalità di trasmissione dei virus
        informatici e la loro rapidità di diffusione, brumbrum non si assume la
        responsabilità in merito ad eventuali danni provocati dalla trasmissione
        di virus non rilevati.
      </p>

      <h4>Disclaimer</h4>
      <p>
        L'uso di questo Sito è a tuo rischio. Pertanto accetti, senza alcuna
        limitazione, che il Sito e tutti i suoi contenuti, ivi compresi i
        servizi, i prodotti, i testi e gli articoli, sono forniti "così come
        sono". brumbrum non rilascia alcun tipo di garanzia riguardo il Sito e i
        suoi contenuti.
      </p>
      <p>
        Riconosci che brumbrum e/o i suoi collaboratori e/o i suoi fornitori non
        potranno essere ritenuti responsabili: i) per qualsiasi danno causato da
        brumbrum, dai suoi collaboratori e fornitori o per i danni comunque
        derivati da questo Sito, salvo il caso di dolo o colpa grave; ii) per
        disfunzioni nell'utilizzazione dei materiali o dei servizi di questo
        Sito causate dal tuo computer o dalle tue apparecchiature.
      </p>
      <p>
        brumbrum non è in alcun modo responsabile di eventuali dati immessi e/o
        falsi e/o mancanti e/o errati, di eventuali perdite di dati immessi, di
        eventuali modifiche ai servizi da parte tua e/o di terzi, di un utilizzo
        scorretto dei servizi, nonché della qualità dei servizi resi.
      </p>
      <p>
        Ti assumi la responsabilità della veridicità, integrità ed eventuale
        perdita dei dati immessi, nonché del corretto utilizzo dei servizi.
      </p>
      <p>
        brumbrum non è in alcun modo responsabile dei contenuti e dei servizi
        posti in siti web a cui l’utente dovesse accedere tramite questo Sito.
      </p>
      <p>
        brumbrum infine non è responsabile per l'attendibilità o la continua
        disponibilità delle linee telefoniche e delle apparecchiature che
        utilizzi per accedere al Sito.
      </p>

      <h4>Limitazioni di responsabilità</h4>
      <p>
        brumbrum non potrà in nessun caso essere ritenuta responsabile per danno
        parziale o totale, diretto o indiretto, legato all’uso del Sito o di
        altri siti web allo stesso collegati da un link- ipertesuale, ivi
        compresi, senza alcuna limitazione, danni quali la perdita di profitti o
        fatturato, l’interruzione di attività aziendale o professionale, la
        perdita di programmi o di altro tipo di dati ubicati nel tuo sistema
        informatico o in altro sistema, ciò anche qualora brumbrum fosse stata
        espressamente messa al corrente della possibilità del verificarsi di
        tali danni.
      </p>
      <p>
        Con questa clausola brumbrum non intende eludere le disposizioni
        previste dalla normativa applicabile, né di escludere la responsabilità
        per i casi nei quali essa non possa essere esclusa ai sensi di detta
        normativa.
      </p>

      <h4>Manleva</h4>
      <p>
        L’utente accetta di indennizzare e mantenere indenne brumbrum, nonché i
        suoi dipendenti, collaboratori e rappresentanti, da qualsiasi obbligo
        risarcitorio verso terzi derivante dal o in qualsiasi modo collegato al,
        tuo utilizzo del Sito e dei relativi servizi, incluse eventuali
        responsabilità o spese legali derivanti da qualsiasi richiesta di
        risarcimento, perdita, danno, causa, sentenza e spese processuali di
        qualsiasi tipo e natura.
      </p>

      <h4>Privacy</h4>
      <p>
        Per quanto riguarda la protezione dei tuoi dati personali e le nostre
        politiche sui cookie, puoi consultare la nostra{' '}
        <a href="/privacy-policy-e-cookies" target="_blank">
          Privacy Policy
        </a>
        .
      </p>

      <h4>Interruzione d’accesso </h4>
      <p>
        brumbrum si riserva il diritto, a sua esclusiva e insindacabile
        discrezione, in qualsiasi momento e senza preavviso, di interrompere il
        tuo accesso o l’accesso di terzi al Sito e ai relativi servizi.
      </p>

      <h4>Modifiche dei termini e delle condizioni</h4>
      <p>
        brumbrum, si riserva il diritto di modificare, a suo esclusivo e
        insindacabile giudizio, in qualsiasi momento e senza alcun preavviso, i
        presenti “Termini di utilizzo”. È interamente a tuo carico la
        responsabilità del controllo costante di detti “Termini di utilizzo”.
        L'utilizzo del Sito e dei relativi servizi, successivo alle intervenute
        modifiche, comporta il tuo assenso alle stesse
      </p>

      <h4>Principi generali applicabili</h4>
      <p>
        L’utilizzo di questo Sito è disciplinato esclusivamente dalla legge
        italiana.
      </p>
      <p>
        Nel caso in cui un qualsiasi termine e/o condizione di utilizzo
        contenuto nelle presenti condizioni generali o un qualsiasi termine e/o
        condizione contenuto in altre parti del Sito dovesse risultare, ai sensi
        della normativa vigente, invalida o non applicabile anche parzialmente,
        la parte del termine o della condizione non affetta da vizio, nonché i
        restanti termini e condizioni, continueranno ad avere piena validità ed
        efficacia.
      </p>
      <p>Data ultimo aggiornamento: 2 marzo 2017</p>
    </div>
  </BuyBigModal>
)

BuyTerminiDiUtilizzo.propTypes = {
  display: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default BuyTerminiDiUtilizzo
